import { addDays, format, isBefore } from 'date-fns';

export const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

export const formatDateTime = (date: Date) => format(date, 'yyyy-MM-dd HH:mm:ss');

export const checkDateRange = (start: Date, end: Date, range: number) => isBefore(addDays(start, range), end);

export const formatTimeZone = (timeZone: string) => (Number(timeZone) >= 0 ? '+' : '') + timeZone;
